import * as React from 'react';
import {
  Box,
  Card,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CardWithIcon from './CardWithIcon';

const API_URL = import.meta.env.VITE_API_URL;

const limit = 5;

const formatName = (u: any) =>
  u.firstName || u.lastName
    ? `${u.firstName || ''} ${u.lastName || ''}`.trim()
    : '-';

const NewCustomers = () => {
  const [users, setUsers] = React.useState<any[]>([]);
  const [total, setTotal] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [animKey, setAnimKey] = React.useState(0);

  const loadUsers = async (pageNum: number) => {
    setLoading(true);

    const res = await fetch(`${API_URL}/users?page=${pageNum}&limit=${limit}`);
    const json = await res.json();

    setUsers(json.data || []);
    setTotal(json.total || 0);

    setLoading(false);
  };

  React.useEffect(() => {
    loadUsers(page);
    setAnimKey((k) => k + 1);
  }, [page]);

  const isLast = page * limit >= total;

  return (
    <CardWithIcon
      to=""
      icon={PersonAddIcon}
      title="Список користувачів"
      subtitle={`${total}`}
    >
      <Card>
        <CardHeader title="Нові користувачі" />

        <Box
          key={animKey}
          sx={{
            minHeight: 500,
            display: 'flex',
            flexDirection: 'column',
            animation: 'fadeSlide 220ms ease-out',
            '@keyframes fadeSlide': {
              from: {
                opacity: 0,
                transform: 'translateY(6px)',
              },
              to: {
                opacity: 1,
                transform: 'translateY(0)',
              },
            },
          }}
        >
          {users.length > 0 && (
            <List dense sx={{ flex: 1 }}>
              {users.map((u) => (
                <ListItem key={u.userId}>
                  <ListItemText
                    primary={
                      <>
                        <Typography variant="body2">
                          @{u.username || '-'}
                        </Typography>
                        <Typography variant="body1">{formatName(u)}</Typography>
                      </>
                    }
                    secondary={`${u.telegramId ? 'Telegram' : 'Viber'} · Місто: ${u?.City?.name || 'Не обрано'}`}
                  />
                </ListItem>
              ))}
            </List>
          )}

          {users.length === 0 && (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
              }}
            >
              Немає нових користувачів
            </Box>
          )}

          {total > limit && (
            <Box
              onClick={() => setPage((p) => (isLast ? 1 : p + 1))}
              sx={{
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: 14,
                p: 1,
              }}
            >
              Показати інших користувачів
            </Box>
          )}
        </Box>
      </Card>
    </CardWithIcon>
  );
};

export default NewCustomers;
